export default __webpack_public_path__ + "static/media/loader.e66aff47.gif";